<template>
    <div class="" :class="classes">
        <ul class="h-7 border-b-2 border-grey-light text-gray-600 list-disc leading-6 tracking-tight xs:border-b-0 xs:border-l-2 xs:h-full xs:ml-2">
            <slot></slot>
        </ul>
    </div>
</template>

<script setup>
    const props = defineProps({
        frontpage: {
            type: Boolean,
            default: false,
        }
    });

    const classes = computed(() => props.frontpage ? 'md:absolute md:top-10 md:right-4 md:w-80 sm:w-28 sm:border-r-2 sm:border-grey-light sm:h-28' : '');
</script>
